/* eslint-disable camelcase,jsx-a11y/anchor-is-valid */
import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';

import styled from 'react-emotion';
import { css } from 'emotion';
import Shiitake from 'shiitake';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import { Link } from 'react-router-dom';

import Discount from '~/modules/ecommerceCoreUI/components/products/offers/OfferTag';
import Follow from '~/modules/ecommerceCoreUI/components/productDetails/vendor/buttons/Follow';
import withVariantData from '~/modules/ecommerceCoreUI/containers/VariantData';
import urlFor from '~/modules/ecommerceCore/utils/UrlConcatination';
import { Label } from '~/modules/coreUI/components/basic/Labels';
import Separator from '~/modules/coreUI/components/layouts/helpers/Separator';
import { LinearLayout, Row } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import ItemImage from '~/modules/ecommerceCoreUI/components/basic/ItemImage';

import ShopRating from '../areas/ProductRating';
import Price from '../areas/Price';
import CartActions from './areas/CartActions';
import PaymentMethods from './areas/PaymentMethods';
import ShippingMethods from './areas/ShippingMethods';

import Layout from './VendorCardLayout';

const Container = styled.div`
  padding: 15px;

  border-radius: 5px;
  background-color: #ffffff;
  border: solid 1px rgba(0, 0, 0, 0.1);
`;

const customRatingStyle = props => css`
  align-items: ${props.media.xsmall && 'flex-end'};
`;

class VendorCard extends React.PureComponent {
  render = () => {
    const {
      media,
      variantInfo: {
        product_type,
        id: variantId,
        discount,
        original_price,
        price,
        total_on_hand,
        gift_text,
        gift_included,
        vendor: {
          ref_id: vendorId,
          name,
          logo_url,
          avg_rating,
          rating_count,
          grouped_shipping_methods,
          payment_methods,
          followed,
        },
        gift_image: {
          url_original,
        },
      },
    } = this.props;

    const getStockLabel = (stockItemsLength) => {
      if (stockItemsLength > 3) {
        return i18next.t('ecommerceCoreUI:Stock.in');
      }
      if (stockItemsLength <= 3 && stockItemsLength > 0) {
        return i18next.t('ecommerceCoreUI:Stock.only', { stockItemsLength });
      }
      return i18next.t('ecommerceCoreUI:Stock.out');
    };

    return (
      <Container key={variantId}>
        <Layout
          logo={
            (
              <Link to={urlFor('getProductTracksLink', [null, vendorId, name])}>
                <ItemImage width={[10, 15]} height={[10, 15]} src={logo_url} />
              </Link>
            )
          }
          title={
            (
              <Link to={urlFor('getProductTracksLink', [null, vendorId, name])}>
                <Label size={['md', 'lg']} important semiBold>
                  <Shiitake lines={1} throttleRate={200}>
                    {name}
                  </Shiitake>
                </Label>
              </Link>
            )
          }
          discount={
            !!discount && (
              <Row>
                <Discount offerType="hasDiscount">
                  {i18next.t(
                    'ecommerceCoreUI:OfferTagTrans.discount',
                    { discount: Math.floor(discount) },
                  )}
                </Discount>
                <Spacer size={1.5} />
              </Row>
            )
          }
          price={
            <Price price={price} oldPrice={discount ? original_price : 0} mobileCard={media.xsmall} />
          }
          stockLabel={
            (
              <Label xs primary>
                {getStockLabel(total_on_hand)}
              </Label>
            )
          }
          rating={
            (
              <ShopRating
                rating={avg_rating}
                ratingCount={rating_count}
                starsSize={media.xsmall && 14}
                customStyle={() => customRatingStyle(this.props)}
              />
            )
          }
          follow={
            (
              <Follow followed={followed} size={['xs', 'sm']} vendorId={vendorId} />
            )
          }
          gift={
            gift_included ? (
              <LinearLayout row={!media.xsmall} bottomAligned={!media.xsmall}>
                <ItemImage
                  src={url_original}
                  width={[4, 5.5]}
                  height={[3.5, 5]}
                />
                <Spacer size={0.5} />
                <Label xs normal>
                  {gift_text}
                </Label>
              </LinearLayout>
            ) : (
              null
            )}
          payment={<PaymentMethods paymentMethods={payment_methods} mobileCard={media.xsmall} />}
          hRule={<Separator separatorLength="full" spacerSize={0.5} />}
          shipping={product_type === 'good' ? <ShippingMethods shippingMethods={grouped_shipping_methods} /> : undefined}
          cartActions={<CartActions variantId={variantId} variant={this.props.variantInfo} />}
        />
      </Container>
    );
  }
}

VendorCard.defaultProps = {
  media: null,
  variantInfo: null,
};

VendorCard.propTypes = {
  media: PropTypes.shape({}),
  variantInfo: PropTypes.shape({}),
};

export default withVariantData(withMedia(VendorCard));
